// This routine returns a valid API key to be used for the new Autotask API
import { client } from "../api/client"
import { getLocalStorage, setLocalStorage } from '../hooks/appVariables'
export const getAutotaskIdToken = async () => {
    const apiKey = getLocalStorage(process.env.REACT_APP_AUTOTASK_API_KEY)
    if (apiKey.length === 0) {
        const policyName = process.env.REACT_APP_AUTOTASK_POLICYNAME
        const application = process.env.REACT_APP_AUTOTASK_APPLICATION

        const payload = {"PolicyName":policyName, "Application":application}
        const uri = 'autotaskapi/auth/token'
        const response = await client.post(uri, JSON.stringify(payload))
        const tokenString = response.data
        const token = tokenString.token
        setLocalStorage(process.env.REACT_APP_AUTOTASK_API_KEY, token)
        return token
    } else {
        return apiKey
    }

}